import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const userToken = useSelector((state) => state?.auth?.token);
  const userId = useSelector((state) => state?.auth?.user?._id);
  const [socket, setSocket] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!userId || !userToken) return;
    
    // Use environment variable for socket URL (configured in .env file)
    const socketUrl = import.meta.env.VITE_SOCKET_URL || window.location.origin;
    
    const newSocket = io(socketUrl, {
      auth: {
        userId,
        token: userToken,
      },
    });

    setSocket(newSocket);

    newSocket.emit("join_room", { userId, role: "admin" });
    newSocket.emit("join_comment_notify", { userId });
    console.log(
      `User ${userId} joined user_${userId} and comment-notify rooms`,
    );

    newSocket.on("update_unread_count", ({ count }) => {
      console.log("update_unread_count:", count);
      setUnreadCount(count);
    });

    newSocket.on("socket-error", ({ message }) => {
      toast.error(message, { position: "top-right" });
    });

    newSocket.on("connect", () => {
      console.log(
        `Socket connected for user ${userId}, socket ID: ${newSocket.id}`,
      );
    });

    newSocket.on("connect_error", (error) => {
      console.error(
        `Socket connection error for user ${userId}:`,
        error.message,
      );
    });

    return () => {
      newSocket.disconnect();
      console.log(`Socket disconnected for user ${userId}`);
    };
  }, [userId, userToken]);

  const markNotificationsRead = () => {
    if (socket) {
      socket.emit("mark_notifications_read", {
        userId,
        role: "admin",
      });
      setUnreadCount(0);
      console.log(`Emitted mark_notifications_read for user ${userId}`);
    }
  };

  return (
    <SocketContext.Provider
      value={{ socket, unreadCount, markNotificationsRead }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  const context = useContext(SocketContext);
  console.log("useSocket context:", context);
  if (!context) {
    throw new Error("useSocket must be used within a SocketProvider");
  }
  return context;
};